import Table from "./Table";
import "./CompactOrderPreviewTable.css";

const CompactOrderPreviewTable = ({ header, body, size }: {
  header: JSX.Element;
  body: JSX.Element;
  size?: "wide" | "narrow";
}) => (
  <div
    dir="rtl"
    className={`compact-order-preview${size ? ` compact-order-preview-${size}` : ""}`}
    role="region"
    aria-label="جدول پیش‌نمایش سفارش"
    tabIndex={0}
  >
    <Table header={header} body={body} />
  </div>
);

export default CompactOrderPreviewTable;
